import { useState } from 'react';
import type { JSX } from 'react';
import type { Palette } from '../../../../_theme/palette.js';
import { hexWithAlpha } from '../../../../_theme/palette.js';

interface YesNoFieldProps {
  palette: Palette;
  value: unknown;
  onChange: (value: boolean) => void;
}

const OPTIONS: { label: string; value: boolean }[] = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const PREMIUM_EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

// Outline-style yes/no. Selected = accent border + accent text on a tinted
// background, not a filled primary.
export function YesNoField({ palette, value, onChange }: YesNoFieldProps): JSX.Element {
  return (
    <div style={{ display: 'flex', gap: 12 }}>
      {OPTIONS.map((option) => (
        <YesNoButton
          key={option.label}
          label={option.label}
          selected={value === option.value}
          palette={palette}
          onClick={() => onChange(option.value)}
        />
      ))}
    </div>
  );
}

function YesNoButton({
  label,
  selected,
  palette,
  onClick,
}: {
  label: string;
  selected: boolean;
  palette: Palette;
  onClick: () => void;
}): JSX.Element {
  const [hovered, setHovered] = useState(false);
  const borderColor = selected
    ? palette.primary
    : hovered
      ? hexWithAlpha(palette.primary, 0.6)
      : palette.border;
  const background = selected
    ? hexWithAlpha(palette.primary, 0.08)
    : palette.card;
  const color = selected
    ? palette.primary
    : hovered
      ? palette.text
      : palette.textMuted;
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="chirp-btn"
      style={{
        flex: 1,
        padding: '12px 14px',
        borderRadius: 8,
        border: `1px solid ${borderColor}`,
        background,
        color,
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
        transition: `border-color 220ms ${PREMIUM_EASE}, background-color 220ms ${PREMIUM_EASE}, color 220ms ${PREMIUM_EASE}`,
      }}
    >
      {label}
    </button>
  );
}
